import React from 'react';
import { HOLDING_STORE_MENU } from '../constants/holdingBrands';
import './ProyectosDigitalesPage.css';

/**
 * Hub Proyectos Digitales — entrada desde hero slide 2 y menú.
 */
const ProyectosDigitalesPage = () => {
  const go = (path) => {
    if (!path) return;
    if (path.startsWith('http')) {
      window.open(path, '_blank', 'noopener,noreferrer');
      return;
    }
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const live = HOLDING_STORE_MENU.filter((b) => b.status === 'live');
  const soon = HOLDING_STORE_MENU.filter((b) => b.status !== 'live');

  return (
    <main className="proyectos-hub">
      <div className="proyectos-hub-inner">
        <p className="proyectos-hub-eyebrow">Javiland · Holding</p>
        <h1 className="proyectos-hub-title">Proyectos digitales</h1>
        <p className="proyectos-hub-lead">
          Ecosistemas que ya operan y otros que están naciendo. Entrá a la tienda live
          o explorá cada marca: canal propio, landing o lista de espera.
        </p>

        <div className="proyectos-hub-store-cta">
          <button type="button" className="proyectos-hub-store-btn" onClick={() => go('/tienda')}>
            Ir a la tienda · Costal Campesino
          </button>
          <p className="proyectos-hub-store-note">
            La despensa del holding (ex «Tienda naturales») vive aquí.
          </p>
        </div>

        {live.length > 0 && (
          <>
            <h2 className="proyectos-hub-section">En vivo</h2>
            <ul className="proyectos-hub-grid">
              {live.map((brand) => (
                <li key={brand.id}>
                  <button
                    type="button"
                    className="proyectos-hub-card is-live"
                    onClick={() => go(brand.menuPath || brand.hubPath)}
                  >
                    <span className="proyectos-hub-card-name">{brand.name}</span>
                    <span className="proyectos-hub-card-tag">{brand.tagline}</span>
                    <span className="proyectos-hub-card-badge">Live</span>
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}

        {soon.length > 0 && (
          <>
            <h2 className="proyectos-hub-section">En construcción</h2>
            <ul className="proyectos-hub-grid">
              {soon.map((brand) => (
                <li key={brand.id}>
                  <button
                    type="button"
                    className="proyectos-hub-card is-soon"
                    onClick={() => go(brand.menuPath || brand.hubPath)}
                  >
                    <span className="proyectos-hub-card-name">{brand.name}</span>
                    <span className="proyectos-hub-card-tag">{brand.tagline}</span>
                    <span className="proyectos-hub-card-badge">Lista de espera</span>
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}

        <button type="button" className="proyectos-hub-back" onClick={() => go('/')}>
          Volver al hub Javiland
        </button>
      </div>
    </main>
  );
};

export default ProyectosDigitalesPage;
